import { render } from "./paramCampaign.vue?vue&type=template&id=6adbb2fe"
import script from "./paramCampaign.vue?vue&type=script&lang=js"
export * from "./paramCampaign.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__